import { actionTypes } from './actions';
import initialState from './initialState';

export default function messagesFiltersReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_TYPE:
      return state.set('type', action.payload);
    case actionTypes.SET_PERIOD:
      return state.set('period', action.payload);
    default:
      return state;
  }
}
